import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { ChangeEvent } from 'react';

interface RadioButtonGroupProps {
  label?: string;
  name: 'position' | 'type' | 'destination';
  value: string;
  options: string[];
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButtonGroup = ({
  label,
  name,
  value,
  options,
  onChange,
}: RadioButtonGroupProps) => {
  const handleRadioChange = (option: string) => {
    onChange({
      target: { name, value: option },
    } as ChangeEvent<HTMLInputElement>);
  };

  return (
    <>
      {label && <label>{label}</label>}
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'column',
          gap: 1,
          padding: 1,
        }}
      >
        <RadioGroup
          row
          name={name}
          value={value}
          onChange={onChange}
          sx={{
            gap: 0.7,
          }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio sx={{ display: 'none' }} />}
              label={
                <Button
                  variant="contained"
                  sx={{
                    flexShrink: 0,
                    flex: '1 1 auto',
                    minWidth: '120px',
                    textTransform: 'none',
                    backgroundColor: value === option ? '#E31E25' : '#333',
                    color: value === option ? '#fff' : '#bbb',
                    borderRadius: 2,
                    boxSizing: 'border-box',
                    '&:hover': {
                      backgroundColor: value === option ? '#C61A20' : '#444',
                    },
                    '&:disabled': {
                      backgroundColor: '#555',
                      color: '#777',
                    },
                  }}
                  onClick={() => handleRadioChange(option)}
                >
                  {option}
                </Button>
              }
            />
          ))}
        </RadioGroup>
      </Box>
    </>
  );
};
